import { getNewsSummaryForSymbol } from './http/quant-ws/v1/news-summaries';
import { Instant } from '@js-joda/core';
import { ONE_MINUTE } from '@thinkalpha/ui-core/util/timeConstants';

const NEWS_SUMMARY = 'news-summary';

export type ISODateString = string;
export type LookBackPeriod = [ISODateString, ISODateString];

export const getNewsSummaryQuery = (tickerSymbol: string, ...lookBackPeriod: LookBackPeriod) => {
    const [from, to] = lookBackPeriod;

    // TODO: The query key doesn't include the time range, so cache invalidation relies entirely
    // on refetchInterval. If the lookback period becomes user-configurable, the key should include
    // something like ['NOW', beginningOfDay(from)] to avoid stale results without constant cache
    // misses. More broadly, this endpoint needs rework to progressively request longer durations
    // based on result count.
    return {
        queryKey: [NEWS_SUMMARY, tickerSymbol],
        queryFn: () => getNewsSummaryForSymbol(tickerSymbol, from, to),
        enabled: !!tickerSymbol,
        refetchInterval: ONE_MINUTE * 5, // refetch every 5 minutes
    };
};

/**
 * Variant of {@link getNewsSummaryQuery} that recomputes `from`/`to` inside
 * the `queryFn` so successive `refetchInterval` invocations always reach back
 * a rolling `windowMs` from the *current* time. Use this when the query is
 * built once and reused across refetches (e.g. behind a long-lived
 * `QueryObserverModel`); the fixed-window factory above is fine when the
 * caller rebuilds the query options on its own cadence.
 */
export const getNewsSummaryRollingQuery = (tickerSymbol: string, windowMs: number) => ({
    queryKey: [NEWS_SUMMARY, tickerSymbol],
    queryFn: () => {
        const now = Instant.now();
        const to = now.toString() as ISODateString;
        const from = now.minusMillis(windowMs).toString() as ISODateString;
        return getNewsSummaryForSymbol(tickerSymbol, from, to);
    },
    enabled: !!tickerSymbol,
    refetchInterval: ONE_MINUTE * 5,
});
